import Swiper, {Autoplay, Navigation, Pagination, EffectFade} from 'swiper';

Swiper.use([Autoplay, Navigation, Pagination, EffectFade]);

let uspsSwiper;

export default class Usps {
    constructor() {
        if (document.getElementById('usp-slider') !== null) {
            this.uspSlider();

        }
    }


    uspSlider() {
        function initSlider() {
            if (uspsSwiper === undefined && window.innerWidth < 992) {
                uspsSwiper = new Swiper('#usp-slider .swiper-container', {
                    slidesPerView: 1,
                    spaceBetween: 30,
                    loop: true,
                    modules: [Autoplay, Pagination],
                    pagination: {
                        el: '#usp-slider .swiper-pagination',
                        clickable: true,
                    },
                    autoplay: {
                        delay: 4500,
                    },
                });
            }
        }

        function destroySlider() {
            if (uspsSwiper !== undefined) {
                uspsSwiper.destroy(true, true);
                uspsSwiper = undefined;
            }
        }

        window.addEventListener('resize', function () {
            if (window.innerWidth < 992) {
                initSlider();
            } else {
                destroySlider();
            }
        });

        // Check initial window width
        if (window.innerWidth < 992) {
            initSlider();
        } else {
            destroySlider();
        }
    }


}
